import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import { defaultStyles, TooltipWithBounds } from '@visx/tooltip';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useReportViewStore } from '../store/view.store';
import { TimelineTooltipContent } from '../timeline/tooltip/TimelineTooltipContent';

/**
 * Renders the stream-quality timeline issue/gap tooltip in a viewport-fixed layer so it is not
 * clipped by chart containers that use `overflow-x: auto` and `overflow-y: hidden`.
 * State lives in `useReportViewStore` (`timelineTooltip` + `setTimelineTooltip`).
 */
export function TimelineTooltipLayer() {
  const theme = useTheme();
  const tooltip = useReportViewStore((s) => s.timelineTooltip);
  const [mountNode, setMountNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setMountNode(document.body);
  }, []);

  if (!mountNode || !tooltip) {
    return null;
  }

  return createPortal(
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: theme.zIndex.tooltip,
      }}
    >
      <TooltipWithBounds
        top={tooltip.clientY}
        left={tooltip.clientX}
        style={{
          ...defaultStyles,
          backgroundColor: 'transparent',
          border: 'none',
          boxShadow: 'none',
          padding: 0,
          zIndex: 1,
        }}
      >
        <Paper elevation={2} variant="outlined">
          <TimelineTooltipContent payload={tooltip.payload} />
        </Paper>
      </TooltipWithBounds>
    </Box>,
    mountNode,
  );
}
